import React, { useState } from 'react';

// Hooks
import { useUpdateAiSetting } from 'Shared/utils/hooks/use-update-ai-setting';
import { useUpdateAiReport } from 'Shared/utils/hooks/use-update-ai-report';

// Components
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import ReportSection from './ReportSection';
import WpTextField from 'Wpds/components/text-field/WpTextField';

// Styles
import './ReportSectionsList.scss';

type Props = {
  updateAiSettingSlug: string;
  handleGenerateReportClick: Function;
};

const ReportSectionsList = ({ updateAiSettingSlug, handleGenerateReportClick }: Props) => {
  const { sections, report } = useUpdateAiSetting({ slug: updateAiSettingSlug });
  const { handleUpdateAiReport, currentlyGeneratingSlugs } = useUpdateAiReport({ slug: report.slug });

  const [name, setName] = useState(report.name);

  const handleUpdateReportNameChange = (value: string) => {
    setName(value);
    handleUpdateAiReport({ name: value });
  };
  const isGenerating = currentlyGeneratingSlugs.length > 0;

  const baseClassName = 'ReportSectionsList';
  return (
    <WpContainer className={baseClassName}>
      <WpContainerBody>
        <div className={`${baseClassName}__title`}>
          <WpTextField
            label="Name"
            id="name"
            value={name || ''}
            placeholder="Give this report a name"
            onChange={handleUpdateReportNameChange}
            readOnly={isGenerating}
            hideBorder
            labelHidden
          />
        </div>
        {sections.map(section => (
          <ReportSection
            key={`editor-section-${section.slug}`}
            section={section}
            updateAiSettingSlug={updateAiSettingSlug}
            handleGenerateReportClick={handleGenerateReportClick}
          />
        ))}
      </WpContainerBody>
    </WpContainer>
  );
};

export default ReportSectionsList;
